import { useState } from 'react';
import { Search } from 'lucide-react';
import './StaffTable.css';

const TeachingStaffList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const staffData = [
    { sNo: 1, name: "MS.NALINI DHINGRA", post: "PRINCIPAL", qualification: "B.Sc., M.A., B.Ed." },
    { sNo: 2, name: "MS.AKANKSHA KHULLAR", post: "P.G.T.", qualification: "M.A (ENG), B.ED., M.B.A, BBA" },
    { sNo: 3, name: "DR.SANJEEV KUMAR GARG", post: "P.G.T.", qualification: "M.Com., B.Ed., M.Phil, MBA, Ph.D." },
    { sNo: 4, name: "MS.PARMJIT KAUR", post: "P.G.T.", qualification: "M.A. (Eng, Education), B.Ed." },
    { sNo: 5, name: "MR.SANDEEP GAUR", post: "P.G.T.", qualification: "M.Sc.(Maths), B.Ed." },
    { sNo: 6, name: "MR.PREM KUMAR SINDHI", post: "P.G.T.", qualification: "M.Sc.(Chem), B.Ed." },
    { sNo: 7, name: "MR.VINOD KUMAR CHHABRA", post: "P.G.T.", qualification: "M.Sc.(Comp.Sc.),M.Com.(EAFM), M.Phil,M.Tech" },
    { sNo: 8, name: "MR.DINESH KUMAR SHARMA", post: "P.G.T.", qualification: "B.Sc., M.A.(Eco.), B.Ed." },
    { sNo: 9, name: "MS.SARIKA SIDANA", post: "P.G.T.", qualification: "MCA, M.Tech." },
    { sNo: 10, name: "MS.MEENAKSHI JAITLY", post: "P.G.T.", qualification: "B.Sc., M.A.(English, Psych.), M.Ed." },
    { sNo: 11, name: "MR.MANOJ JAITLY", post: "P.E.T.", qualification: "B.Com, M.Com., M.P.Ed.(Physical)" },
    { sNo: 12, name: "MR.DHARMENDER KRISHAN", post: "P.G.T.", qualification: "M.A. Fine Arts" },
    { sNo: 13, name: "MR.MUKESH KUMAR AGGAR.", post: "P.G.T.", qualification: "B.Sc., M.Sc.(Botany), B.Ed." },
    { sNo: 14, name: "MR.RAVINDER PARMAR", post: "P.G.T.", qualification: "B.Com., M.Com.(Int.Buss.), B.Ed." },
    { sNo: 15, name: "MR.JASJEET SINGH JORA", post: "P.G.T.", qualification: "B.Tech., M.Sc.(Phy.), B.Ed." },
    { sNo: 16, name: "MR.SURENDER KUMAR HARJAI", post: "P.G.T.", qualification: "B.A., M.A.(Eng.Pol.Sc.,His.), B.Ed." },
    { sNo: 17, name: "MS.ANITA NAIN", post: "P.G.T.", qualification: "B.A., M.A. (History), B.Ed." },
    { sNo: 18, name: "MR.SANDEEP BISHNOI", post: "P.E.T.", qualification: "B.A, B.EPD.,M.PED" },
    { sNo: 19, name: "MS. RAVNEET KAUR", post: "P.G.T.", qualification: "M.A.(Soci., Eco.), B.Ed., M.Ed., Ph.D. Pursuing" },
    { sNo: 20, name: "DR.LATIKA DEVI", post: "T.G.T", qualification: "B.A., M.A.(Sanskrit), B.Ed." },
    { sNo: 21, name: "MS.MONA ARORA", post: "T.G.T", qualification: "B.Sc, M.Sc. (Chemistry), B.Ed." },
    { sNo: 22, name: "MS.RAJNI BALA", post: "T.G.T", qualification: "B.Sc (Medical), M.SC (Chem.), B.Ed." },
    { sNo: 23, name: "MS.JEETENDER PREET KAUR SANDHU", post: "T.G.T", qualification: "B.Sc., M.Sc.(Zoology), B.Ed." },
    { sNo: 24, name: "MR.MADHU SUDAN KAUSHIK", post: "T.G.T", qualification: "B.A., M.A. (Hindi, Sanskrit), B.Ed." },
    { sNo: 25, name: "MS.RITU SHARMA TIWARI", post: "T.G.T", qualification: "M.Sc.(Chem), B.Ed., Ph.D." },
    { sNo: 26, name: "MS.SUNITA SOBTI", post: "T.G.T", qualification: "B.A., B.Ed." },
    { sNo: 27, name: "MS.AMARDEEP KAUR NARANG", post: "T.G.T", qualification: "B.A., M.Sc.(Comp.Sc.), DCA, DLED" },
    { sNo: 28, name: "MS.MUKTA MANISHA", post: "T.G.T", qualification: "B.A., M.A.(Hindi Lit), B.Ed." },
    { sNo: 29, name: "MS.ANJANA", post: "T.G.T", qualification: "M.A (Lib Ed), B.A (Addetional), M.A. (English), B.ED." },
    { sNo: 30, name: "MS.RAJNI BALA SIKKA", post: "T.G.T", qualification: "B.Ed. (Math, Punjabi)" },
    { sNo: 31, name: "MR.PAWAN KUMAR CHUGH", post: "T.G.T", qualification: "B.Sc., B.Ed." },
    { sNo: 32, name: "MS.ARCHANA MAHESHWARI", post: "T.G.T", qualification: "B.A., M.A.(Eng.), B.Ed., TTC, Ph.D.in Yoga" },
    { sNo: 33, name: "MS.RACHANA SHARMA", post: "T.G.T", qualification: "B.SC, M.SC., B.Ed." },
    { sNo: 34, name: "MS.DEEPIKA", post: "T.G.T", qualification: "B.A. (Hindi, Economics, Political Science), M.A. (Economics), B.Ed." },
    { sNo: 35, name: "MS.SUKHJEET KAUR", post: "T.G.T", qualification: "M.A Punjabi, B.Ed." },
    { sNo: 36, name: "MR.MAHESH", post: "T.G.T", qualification: "M.A (English & Arts), B.Ed." },
    { sNo: 37, name: "MS.RUPINDER KAUR GILL", post: "T.G.T", qualification: "M.A. (English), B.Ed." },
    { sNo: 38, name: "MR.KARAN CHAWLA", post: "T.G.T", qualification: "M.SC (Math), B.Ed." },
    { sNo: 39, name: "MR.RAJOO KUMAR NISHAD", post: "T.G.T", qualification: "B.Tech. D.EL.ED" },
    { sNo: 40, name: "MR.ANURAG KATHAK", post: "T.G.T", qualification: "B.A. Vishard, Sangeet Vishard, Kathak" },
    { sNo: 41, name: "MS.SHRUTI SHARMA", post: "T.G.T", qualification: "B.I.M., M.A., B.Ed., M.B.A" },
    { sNo: 42, name: "MS.AVANTIKA", post: "T.G.T", qualification: "M.SC, B.Ed." },
    { sNo: 43, name: "MS.SIJI JOY", post: "T.G.T", qualification: "M.SC, B.Ed." },
    { sNo: 44, name: "MS.NISHA CHALANA", post: "T.G.T", qualification: "B.sc, B.Ed" },
    { sNo: 45, name: "NISHA", post: "T.G.T", qualification: "M.PHIL, B.Ed" },
    { sNo: 46, name: "MS.RACHNA MUNJAL", post: "P.R.T", qualification: "B.A., B.Ed." },
    { sNo: 47, name: "MS.KRISHNA", post: "P.R.T", qualification: "M.Com., M.A.(Yoga), YTTC 200hrs.(Yoga)" },
    { sNo: 48, name: "MS.JASPREET KAUR", post: "P.R.T", qualification: "B.A, M.A." },
    { sNo: 49, name: "MS.PRATIMA JUNEJA", post: "P.R.T", qualification: "M.A (English), B.Ed." },
    { sNo: 50, name: "MS.JYOTI SINGAL", post: "P.R.T", qualification: "MBA (Finance), B.Ed." },
    { sNo: 51, name: "MS.RITU BHATIA", post: "P.R.T", qualification: "M.A (Punjabi, History), B.ED." },
    { sNo: 52, name: "MS.ARUNA JAIN", post: "P.R.T", qualification: "M.SC.(Computer Science), M.C.A" },
    { sNo: 53, name: "MS.ROZY", post: "P.R.T", qualification: "M.A (Hindi), BE.D" },
    { sNo: 54, name: "MS.SHEENA SOBTI", post: "P.R.T", qualification: "B.COM., M.COM, M.A. (English)" },
    { sNo: 55, name: "MS.SAVITA JAGGA", post: "P.R.T", qualification: "B.A., B.Ed." },
    { sNo: 56, name: "MS.MONIKA KHANNA", post: "P.R.T", qualification: "B.COM, M.COM (Accountancy)" },
    { sNo: 57, name: "MS.BHARTI", post: "P.R.T", qualification: "M.A, B.Ed" },
    { sNo: 58, name: "MS.BHOOMIKA", post: "P.R.T", qualification: "M.A, B.Ed" },
    { sNo: 59, name: "MRS.RENU BHATI", post: "P.R.T", qualification: "M.A, B.Ed" },
    { sNo: 60, name: "MS.KAMINI BAJAJ", post: "P.R.T", qualification: "B.Com., M.Com.(ABST), B.Ed." },
    { sNo: 61, name: "MS.SWETA BATRA", post: "P.R.T", qualification: "M.A, B.Ed" },
    { sNo: 62, name: "MS. MUSKAN SHARMA", post: "P.R.T", qualification: "B.A., M.A.(English), B.Ed." },
    { sNo: 63, name: "MS.JITENDRA KUMAR", post: "P.R.T", qualification: "B.COM., MBA, B.PED." },
    { sNo: 64, name: "MS.SUNITA RANI", post: "P.R.T", qualification: "B.A., B.ED, M.ED FRENCH DIPLOMA" },
    { sNo: 65, name: "MS. UDITI AGGARWAL", post: "T.G.T", qualification: "B.A.+B.Ed., M.A. (Geography) Pursuing" },
    { sNo: 66, name: "MS. CHANDANDEEP", post: "T.G.T", qualification: "B.SC., M.SC.(Math), B.Ed." },
    { sNo: 67, name: "MS. PRIYANKA BISHNOI", post: " Teacher", qualification: "M.SC.(Bio-Technology), B.Ed." },
    { sNo: 68, name: "MS. SHILPI BISHNOI", post: " Teacher", qualification: "B.COM, M.COM (EAFM), M.B.A. (Marketing)" },
    { sNo: 69, name: "MR. HARSHIT GUMBER", post: " Teacher", qualification: "B.A., B.PED., M.A.(English)" },
  ];

  const filteredStaff = staffData.filter(staff =>
    staff.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    staff.post.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentStaff = filteredStaff.slice(startIndex, endIndex);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const getPostClass = (post) => {
    if (post.includes('PRINCIPAL')) return 'badge-principal';
    if (post.includes('P.G.T') || post.includes('P.E.T')) return 'badge-pgt';
    if (post.includes('T.G.T')) return 'badge-tgt';
    if (post.includes('P.R.T')) return 'badge-prt';
    if (post.includes('I.B')) return 'badge-other';
    return 'badge-other';
  };

  return (
    <div className="staff-container">
      {/* Banner Section */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>Teaching Staff</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Teaching Staff</li>
          </ul>
        </div>
      </section>

      <div className="main-content">
        {/* Search Bar */}
        <div className="search-container">
          <div className="search-wrapper">
            <Search className="search-icon" size={20} />
            <input
              type="text"
              placeholder="Search by name or designation..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Items per page selector */}
        <div className="items-selector">
          <div className="selector-left">
            <label className="selector-label">Show:</label>
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className="selector-dropdown"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={staffData.length}>All</option>
            </select>
            <span className="selector-text">entries</span>
          </div>
          <div className="selector-info">
            Showing {startIndex + 1} to {Math.min(endIndex, filteredStaff.length)} of {filteredStaff.length} entries
          </div>
        </div>

        {/* Staff Table */}
        <div className="table-container">
          <div className="table-wrapper">
            <table className="staff-table">
              <thead>
                <tr className="table-header-row">
                  <th className="table-header">S. No.</th>
                  <th className="table-header">Name of Employee</th>
                  <th className="table-header">Designation</th>
                  <th className="table-header">Qualifications</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {currentStaff.map((staff) => (
                  <tr key={staff.sNo} className="table-row">
                    <td className="table-cell cell-number">{staff.sNo}</td>
                    <td className="table-cell cell-name">{staff.name}</td>
                    <td className="table-cell">
                      <span className={`badge ${getPostClass(staff.post)}`}>
                        {staff.post}
                      </span>
                    </td>
                    <td className="table-cell cell-qualification">{staff.qualification}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {currentStaff.length === 0 && (
            <div className="no-results">
              <p>No staff members found matching your search.</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Previous
            </button>
            
            {getPageNumbers().map((page, index) => (
              page === '...' ? (
                <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`pagination-btn ${currentPage === page ? 'pagination-active' : ''}`}
                >
                  {page}
                </button>
              )
            ))}
            
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        )}

        {/* Footer */}
        <div className="footer">
          <p>Page {currentPage} of {totalPages}</p>
        </div>
      </div>
    </div>
  );
};

export default TeachingStaffList;